<template lang="pug">
modal(id="clone-grid", ref="modal", :loading="onLoading('clone-order-layout')")
    template(slot="title") Copy Grid Layout
    template(slot="footer")
        button.btn.btn-fw.primary(@click="submit" :disabled="onLoading('clone-order-layout')")
            v-loading(loader="clone-order-layout") Copy
    template(slot="body")
        form(@submit.prevent="submit", v-if="orderLayout !== null")
            fieldset(:disabled="onLoading('clone-order-layout')")
                .col-md-12
                    p.m-b-0 Copy 
                        span._500 {{ orderLayout.name }} 
                        | grid layout to :

                    .md-form-group
                        label._500 Select Outlet
                        multiselect(
                                :options="outletList",
                                v-model="orderLayout.outlet_id",
                                track-by="id",
                                label="name",
                                :placeholder="select_outlets"
                                v-validate="'required'"
                                @search-change="refreshOutletList"
                                :loading="onLoading('fetch-outlet')"
                                :value="outletList.id"
                        )
                        span.text-danger.block(v-show="errors.has('outlet')") {{ errors.first('outlet') }}
</template>

<script>
import { OrderLayoutEvent } from './order-layout-bus';
import { mapActions, mapGetters } from 'vuex';
import Feature from '@js/plugins/feature';

export default {
    data() {
        let select_outlets = 'Select Outlets';

        if (Feature.hasFeature('fuel')) {
            select_outlets = 'Select Stations';
        }

        return {
            select_outlets,
            outlets_loading: false,
            outlets: [],
            orderLayout: null,
        };
    },

    computed: {
        ...mapGetters('outlet', ['outletList']),
    },

    mounted() {
        OrderLayoutEvent.$on('clone-order-layout', orderLayout => {
            this.orderLayout = orderLayout;
            this.$refs.modal.$emit('show');
        });
    },

    created() {
        this.getOutletList();
    },

    methods: {
        ...mapActions('orderLayout', ['cloneOrderLayout']),
        ...mapActions('outlet', ['getOutletList', 'getOutletListIfNecessary']),

        async submit() {
            const validate = await this.$validator.validateAll();
            if (!validate) return;

            this.startLoading('clone-order-layout');

            try {
                const outlet_id = this.orderLayout.outlet_id.id;

                const orderLayoutData = Object.assign(
                    _.pick(this.orderLayout, [
                        'id',
                        'name',
                        'description',
                        'width',
                        'height',
                        'centrals',
                        'outlet',
                    ]),
                    {
                        outlet_id,
                    },
                );
                const orderLayout = await this.cloneOrderLayout(
                    orderLayoutData,
                );

                location.href = Laroute.route('franchise.order_layout.show', {
                    id: orderLayout.id,
                });
            } catch (e) {
                this.endLoading('clone-order-layout');
                swal({
                    type: 'error',
                    title: 'Oops...',
                    text: e,
                });
            }
        },

        refreshOutletList: _.debounce(function(query) {
            this.getOutletListIfNecessary({ query: query });
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-clone.vue